import API from '@aws-amplify/api';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './Schools.scss';

function Schools() {
    const [t] = useTranslation();

    useEffect(() => {
        (async () => {
            let response = await API.get('ShipyardAPI', '/schools');
            console.log('API Gateway responded with', response);
        })();
    }, []);

    return <div>{t('Schools.Placeholder')}</div>;
}

export default Schools;
